import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import Cube from 'cube-ui'
import { Input,Timeline,Alert,MessageBox,Message} from 'element-ui'
import $ from 'jquery'
import "mint-ui/lib/style.css";
import 'element-ui/lib/theme-chalk/index.css';
import { Swipe, SwipeItem ,Loadmore} from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Loadmore.name, Loadmore);
Vue.use(Cube)
Vue.use(Input)
Vue.use(Alert);
// Vue.use(Timeline,Timeline-Item)
Vue.config.productionTip = false
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message


new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
